import React from "react";
import { motion } from "framer-motion";
import { MaskedLine, FadeUp } from "./MaskedReveal";

const shots = [
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/dncpttzu_515147-Cessna-408-SkyCourier-007-881831-original-1701193735-v2.webp",
    label: "C408 SkyCourier · golden hour",
    ratio: "aspect-[16/9]",
    col: "md:col-span-8",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/345d7k6y_IMG_7905.webp",
    label: "King Air 260 · N686RR · hangar",
    ratio: "aspect-[4/5]",
    col: "md:col-span-4",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/181exr9f_IMG_2883.webp",
    label: "King Air · mission-ready · hangar floor",
    ratio: "aspect-[16/9]",
    col: "md:col-span-7",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/904g2blw_IMG_1247.webp",
    label: "Flight deck · pre-departure",
    ratio: "aspect-[4/5]",
    col: "md:col-span-5",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/yykbciwz_IMG_1187.webp",
    label: "Line-up · turbine fleet",
    ratio: "aspect-[16/9]",
    col: "md:col-span-6",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/7a2ppqvk_IMG_8086.webp",
    label: "En-route · terrain and weather",
    ratio: "aspect-[16/9]",
    col: "md:col-span-6",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/4c6sgtr8_IMG_1758.webp",
    label: "Dusk cruise · above the horizon",
    ratio: "aspect-[21/9]",
    col: "md:col-span-12",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/krxnxgfr_IMG_2076.webp",
    label: "Turbine ops · field notes",
    ratio: "aspect-[4/5]",
    col: "md:col-span-4",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/svr8p4jw_IMG_1067.webp",
    label: "Ramp light · mission-ready",
    ratio: "aspect-[4/5]",
    col: "md:col-span-4",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/71syx8oz_242887bf-63f7-4001-b9dd-7c62e3ce3fa8.JPG",
    label: "Fleet moment · airframe up close",
    ratio: "aspect-[4/5]",
    col: "md:col-span-4",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/eaytoxij_IMG_0242.webp",
    label: "King Air 350 · hangar apron",
    ratio: "aspect-[4/5]",
    col: "md:col-span-4",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/ejv5heul_IMG_6533.webp",
    label: "Delivery handoff · client care",
    ratio: "aspect-[4/5]",
    col: "md:col-span-5",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/9zsdzw3j_IMG_8412.webp",
    label: "N686RR · post-delivery",
    ratio: "aspect-[16/9]",
    col: "md:col-span-7",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/vm9t3tpb_IMG_8699.webp",
    label: "TG-FLY · King Air · night hangar",
    ratio: "aspect-[21/9]",
    col: "md:col-span-12",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/zt98v1nt_PHOTO-2025-09-28-18-51-09.JPG",
    label: "Ramp crew · pre-departure",
    ratio: "aspect-[16/9]",
    col: "md:col-span-7",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/dbpromjj_276127378_272169078439766_1640662930940077586_n.jpg",
    label: "International handoff · ramp",
    ratio: "aspect-[4/5]",
    col: "md:col-span-5",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/xjtgyiio_276318447_272169151773092_1392172800671739356_n.jpg",
    label: "Flight deck · two-crew ops",
    ratio: "aspect-[4/5]",
    col: "md:col-span-5",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/p7i156qd_IMG_2891.png%20estaaaaaa.webp",
    label: "King Air 350 · overhead pass",
    ratio: "aspect-[16/9]",
    col: "md:col-span-7",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/xfpr8rl7_IMG_3418.webp",
    label: "King Air 350i · high-desert ramp",
    ratio: "aspect-[21/9]",
    col: "md:col-span-12",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/igldrqzs_00f5c2b0-3ae4-45b1-ab3a-8567e564e982.JPG",
    label: "Cabin · crew mid-mission",
    ratio: "aspect-[16/9]",
    col: "md:col-span-7",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/4jb8rpzk_01A957CF-B853-45ED-9B55-0AEDBAE5866F.JPG",
    label: "N60KA · King Air 350 · in flight",
    ratio: "aspect-[16/9]",
    col: "md:col-span-5",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/1cizv3qq_EFE44062-907B-4AA3-A981-582F21212305.JPG",
    label: "N60KA · takeoff roll",
    ratio: "aspect-[16/9]",
    col: "md:col-span-6",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/xut6w07i_d4e4cff8-ea81-4c54-a266-52653504b72b.JPG",
    label: "Taipei arrival · King Air taxi",
    ratio: "aspect-[16/9]",
    col: "md:col-span-6",
  },
];

export const Gallery = () => {
  return (
    <section
      id="gallery"
      className="relative bg-[#050505] py-24 md:py-40 border-t border-white/10"
      data-testid="gallery-section"
    >
      <div className="mx-auto max-w-[1920px] px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 mb-16 md:mb-24">
          <div className="md:col-span-6">
            <FadeUp>
              <div className="font-mono-label text-white/50 mb-6">
                <span className="text-[#FF5A00]">◉</span> Gallery · Field Notes
              </div>
            </FadeUp>
            <h2 className="font-display text-5xl md:text-7xl uppercase leading-[0.9] tracking-tight">
              <MaskedLine>Cockpits,</MaskedLine>
              <MaskedLine delay={0.15}>
                <span className="font-serif-italic italic text-white/70">
                  cabins,
                </span>{" "}
                horizons.
              </MaskedLine>
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8 flex items-end">
            <FadeUp delay={0.2}>
              <p className="text-white/60 text-base md:text-lg leading-relaxed max-w-md">
                A visual notebook — moments from training flights, deliveries,
                and hangar mornings. Every frame, one airplane.
              </p>
            </FadeUp>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
          {shots.map((s, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 80 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0, margin: "0px 0px -10% 0px" }}
              transition={{
                duration: 1.2,
                ease: [0.76, 0, 0.24, 1],
                delay: (i % 2) * 0.1,
              }}
              className={`relative ${s.col} col-span-1`}
              data-testid={`gallery-shot-${i}`}
            >
              <div
                className={`relative corner-frame overflow-hidden spotlight-img ${s.ratio} w-full`}
              >
                <img
                  src={s.src}
                  alt={s.label}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1500ms] ease-out hover:scale-105"
                />
              </div>
              <figcaption className="mt-4 flex items-center justify-between font-mono-label text-white/50">
                <span>{String(i + 1).padStart(2, "0")}</span>
                <span className="text-white/60">{s.label}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
